'use strict';
define([
    '../data/config/app',
    '../../../lib/domQ',
    './Search',
    './util',
    './DropdownMenu',
    './miniBag/Index',
    './navigation/Breakpoint',
    './links/Index',
    './links/cookieService',
    './MyBag',
    './HdrSiteStripe',
    './stickyHeader',
    './cookieBanner.js',
    './GeoOverlay.js',
    './links/sparksDashboard'

], function (config, domQ, Search, util, DropdownMenu, MiniBagOverlay, Breakpoint, HeaderLinks, mnsCookieService, MyBag, HdrSiteStripe, stickyHeader, cookieBanner, GeoOverlay, sparksDashboard) {

    function Header() {

        var requestParams = {
            storeId: config.storeId,
            langId: config.langId,
            catalogId: config.catalogId
        };
        var CLEAR = 'Clear';
        // toggle header links
        new HeaderLinks(document.querySelector('#progressiveHeaderSection')).show();
        var geoSession = 'MS_PREFERRED_COUNTRY';
        if (window && window.sessionStorage && !window.sessionStorage[geoSession]) {
            GeoOverlay.init();
        }
        // bag
        new MyBag({
            myBagCount: document.querySelector('.navigation-nav-header__bag-count'),
            myBagElement: document.getElementsByClassName('navigation-res-nav-header__item--bag')[0],
            checkoutElement: document.getElementsByClassName('navigation-res-nav-header__item--checkout')[0],
            myBagIconElement: document.querySelector('.navigation-res-nav-header__item--bag .navigation-primary__menu-icon')
        });

        var basketHolder = '';
        if (document.querySelector('.navigation-res-icon--empty-my-bag')) {
            basketHolder = window.getComputedStyle(
                document.querySelector('.navigation-res-icon--empty-my-bag'), ':before'
            );
        }
        if (document.querySelector('.navigation-res-icon--fill-my-bag')) {
            basketHolder = window.getComputedStyle(
                document.querySelector('.navigation-res-icon--fill-my-bag'), ':before'
            );
        }
        if (basketHolder && basketHolder.backgroundImage) {
            basketHolder = basketHolder.backgroundImage;
            var basketImgLen = basketHolder.length - 2;
            var tempBasketImg = document.createElement('img');
            tempBasketImg.src = basketHolder.substring(5, basketImgLen);
            tempBasketImg.addEventListener('load', loadBagCount);
            window.setTimeout(loadBagCount, 8000);
        }
        function loadBagCount() {
            document.querySelector('.navigation-nav-header__bag-count').style.display = 'block';
        }
        //Cookie Banner
        if (!document.cookie.match('CONSENTMGR')&&!window.MS_ROI_COOKIE_BANNER_ENABLE ) {
            cookieBanner.bind();
        }
        document.addEventListener('touchend', touchHandlerForDropdown, true);

        /* my account bindings */
        var myAccountSparkLink = document.querySelector('.navigation-res-nav-header__item.navigation-myaccount  #myAccountSparkLink');
        var signInSparkLink = document.querySelector('.navigation-header__sparks-link-signin');
        var sparksUserLink = 'data-sparks-login-link';
        if (mnsCookieService.isUserLoggedIn() && mnsCookieService.isUserSparksMember()) {
            sparksUserLink = 'data-sparks-hub-link';
        }

        if (myAccountSparkLink) {
            if (myAccountSparkLink.getAttribute(sparksUserLink).indexOf('intid') !== -1) {
                var sparksUrl = myAccountSparkLink.getAttribute(sparksUserLink).replace(/(intid=).*?(#|$)/, '$1' + 'header_account_sparks');
                myAccountSparkLink.setAttribute(sparksUserLink, sparksUrl);
                myAccountSparkLink.setAttribute('href', myAccountSparkLink.getAttribute(sparksUserLink));
            } else {
                var sparksurl = myAccountSparkLink.getAttribute(sparksUserLink);
                var newSparksurl = sparksurl + '#intid=header_account_sparks';
                myAccountSparkLink.setAttribute(sparksUserLink, newSparksurl);
                myAccountSparkLink.setAttribute('href', myAccountSparkLink.getAttribute(sparksUserLink));
            }
        }

        if (signInSparkLink) {
            if (signInSparkLink.getAttribute(sparksUserLink).indexOf('intid') !== -1) {
                var sparksUrl1 = signInSparkLink.getAttribute(sparksUserLink).replace(/(intid=).*?(#|$)/, '$1' + 'header_sign-in_sparks');
                signInSparkLink.setAttribute(sparksUserLink, sparksUrl1);
                signInSparkLink.setAttribute('href', signInSparkLink.getAttribute(sparksUserLink));
            } else {
                var sparksurl1 = signInSparkLink.getAttribute(sparksUserLink);
                var newSparksurl1 = sparksurl1 + '#intid=header_sign-in_sparks';
                signInSparkLink.setAttribute(sparksUserLink, newSparksurl1);
                signInSparkLink.setAttribute('href', signInSparkLink.getAttribute(sparksUserLink));
            }

        }
        // SparksPay Binding
        var getsparkspayIcon = document.querySelector('.navigation-icon--accountsparkspay');
        var getSparksPayStatus = mnsCookieService.getUserSparkspayStatus();
        var sparksPayLinkHref = document.querySelector('.navigation-res-nav-header__item.navigation-myaccount  #myAccountSparkPayLink');
        if (sparksPayLinkHref) {
            var sparksPayAccountLink = sparksPayLinkHref.getAttribute('data-sparks-accountservice-link');
            var sparksPayLandingpageLink = sparksPayLinkHref.getAttribute('data-sparks-landingpage-link');
        }
        if (mnsCookieService.isUserLoggedIn() && (getSparksPayStatus === 'COMPLETED')) {
            if (sparksPayLinkHref) {
                sparksPayLinkHref.href = sparksPayAccountLink;
            }
        }
        else if (mnsCookieService.isUserLoggedIn() && (getSparksPayStatus !== 'COMPLETED' || getSparksPayStatus === null)) {
            if (sparksPayLinkHref) {
                sparksPayLinkHref.href = sparksPayLandingpageLink;
            }
        }
        if (mnsCookieService.isUserLoggedIn() && (getSparksPayStatus !== null) && getsparkspayIcon) {
            domQ(getsparkspayIcon).addClass('navigation-sparkspaygreendot');
        }
        // add toggle behavior to all #menuBarTop dropdowns (remove 'find a store' explicitly, 'search' & 'save for later' not included)
        var dropdownMenu = new DropdownMenu(document.getElementById('menuBarTop'), {
            menuItem: '.navigation-dropdown:not(.navigation-res-nav-header__item--location)',
            menuItemLink: '.navigation-dropdown__menuitem-link',
            menuDropdown: '.navigation-dropdown__panel-wrapper',
            namespace: 'HEADER_DROPDOWN_MENU'
        });

        // Search typeahead
        var searchContainer = document.querySelector('.navigation-res-nav-header__dropdown--search'),
            searchCommand = searchContainer.querySelector('#searchSuggestionCmd').value,
            navVeil = document.querySelector('.navigation-veil-search'),
            searchContainerParentOverlay = document.querySelector('.navigation-search-overlay'),
            searchButton = document.querySelector('.navigation-btn__icon--search-container');

        var search = new Search({
            'searchContainer': searchContainer,
            'command': config.wcsBaseUrl + searchCommand,
            'navVeil': navVeil,
            'searchContainerParentOverlay': searchContainerParentOverlay,
            'searchButton': searchButton
        });
        search.init(requestParams.storeId);

        // add toggle behavior to 'search' & 'save for later' dropdowns for xsmall/small viewports
        this.searchIconDisplay = document.querySelector('.navigation-dropdown__panel--search');
        this.headerSection = document.getElementById('progressiveHeaderSection');
        if (Breakpoint.size() === 'xsmall') {
            //dropdown__panel-wrapper
            if (this.searchIconDisplay) {
                domQ(this.searchIconDisplay).removeClass('navigation-dropdown__panel-wrapper', 'navigation-dropdown__panel--search');
                domQ(this.searchIconDisplay).addClass('navigation-dropdown__panel-wrapper__new', 'navigation-dropdown__panel--search');
                dropdownMenu.addMenuItemLink(document.querySelector('.res-nav-header__fav-icon.navigation-dropdown__menuitem-link'), document.querySelector('.navigation-res-nav-header__item--fav .navigation-dropdown__panel-wrapper'));
            }
            if (window.mobileSearchKey) { // collapsed search view
                domQ(this.headerSection).addClass('navigation-header-height');
            } else { // exposed search view
                domQ(this.headerSection).removeClass('navigation-header-height');
            }
        } else if (Breakpoint.size() === 'small') {
            if (this.searchIconDisplay) {
                domQ(this.searchIconDisplay).removeClass('navigation-dropdown__panel-wrapper__new', 'navigation-dropdown__panel--search');
                domQ(this.searchIconDisplay).addClass('navigation-dropdown__panel-wrapper', 'navigation-dropdown__panel--search');
            }
        }
        // add toggle behavior to 'find a store' dropdown for other than xsmall viewport
        var findStoreItem = document.querySelector('.navigation-res-nav-header__item--location'),
            findStoreIcon = findStoreItem ? findStoreItem.querySelector('.navigation-res-nav-header__icon--location') : null;
        // Adding store location url parameters
        if (findStoreIcon) {
            findStoreIcon.href += '?langId=' + requestParams.langId + '&storeId=' + requestParams.storeId + '&catalogId=' + requestParams.catalogId;
        }

        // add url params to 'find store' button in gnav for xsmall viewport
        var findStoreItemBottom = document.querySelector('.navigation-bottom--find-store'),
            findStoreIconBottom = findStoreItemBottom ? findStoreItemBottom.querySelector('.nav-primary__menu-link--find-store') : null;
        // Adding store location url parameters
        if (findStoreIconBottom) {
            findStoreIconBottom.href += '?langId=' + requestParams.langId + '&storeId=' + requestParams.storeId + '&catalogId=' + requestParams.catalogId;
        }
        setTimeout(function() {
            if(window.mnsHeaderConfig && window.mnsHeaderConfig.adobeTargetTest) {
                config = window.mnsHeaderConfig;
            }
            // initialize mini bag overlay for iPad/large viewport
            if (Breakpoint.size() === 'small') {
                MiniBagOverlay.initialize(document.querySelectorAll('#miniBagOverlayHeader'), {
                    miniBagCMD: config.wcsBaseUrl + config.CMD.miniBasket + '?langId=' + requestParams.langId + '&storeId=' + requestParams.storeId + '&catalogId=' + requestParams.catalogId
                });
            }
            if (Breakpoint.size() === 'medium' || Breakpoint.size() === 'large') {
                MiniBagOverlay.initialize(document.querySelectorAll('#miniBagOverlayHeader'), {
                    miniBagCMD: config.wcsBaseUrl + config.CMD.miniBasket + '?langId=' + requestParams.langId + '&storeId=' + requestParams.storeId + '&catalogId=' + requestParams.catalogId
                });
                this.inputField = document.querySelector('.navigation-dock-search-popup .navigation-search-bar--search-wrap input');
                this.inputField.addEventListener('keydown', function (evt) {
                    var inputsearchIconblack = document.querySelector('.navigation-btn__blackicon--search');
                    var recentClearTextelement = document.querySelector('.navigation-suggestion-item--clear-text');
                    var overlaycrossIcon = document.querySelector('.navigation-dock-search-popup .navigation-search-bar--clear');
                    this.SuggessionListItem = document.querySelectorAll('.navigation-search-item--list a');
                    this.lastSuggessionListItem = this.SuggessionListItem[this.SuggessionListItem.length - 1];
                    overlaycrossIcon.tabIndex = '-1';
                    var keyPressed = evt.key || evt.keyCode;
                    if (keyPressed === 'Tab' || keyPressed === 9) {
                        if (document.querySelector('.navigation-recentsearch--list li')) {
                            recentClearTextelement.addEventListener('keydown', function (evt) {
                                var overlayInputField = document.querySelector('.navigation-dock-search-popup .navigation-search-bar--search-wrap input');
                                var keyPressed = evt.key || evt.keyCode;
                                if (keyPressed === 'Tab' || keyPressed === 9) {
                                    if (overlayInputField.value === '') {
                                        overlayInputField.focus();
                                        evt.preventDefault();
                                    }
                                    else {
                                        inputsearchIconblack.focus();
                                        overlaycrossIcon.tabIndex = '0';
                                        evt.preventDefault();
                                    }
                                }
                            });
                        }
                        else if (!recentClearTextelement && this.lastSuggessionListItem) {
                            this.lastSuggessionListItem.addEventListener('keydown', function (evt) {
                                var keyPressed = evt.key || evt.keyCode;
                                if (keyPressed === 'Tab' || keyPressed === 9) {
                                    inputsearchIconblack.focus();
                                    overlaycrossIcon.tabIndex = '0';
                                    evt.preventDefault();
                                }
                            });
                        }
                        else if (!recentClearTextelement && !this.lastSuggessionListItem) {
                            overlaycrossIcon.tabIndex = '0';
                            overlaycrossIcon.addEventListener('keydown',function(evt){
                                var keyPressed = evt.key || evt.keyCode;
                                if (keyPressed === 'Tab' || keyPressed === 9) {
                                    search.resetSearchText();
                                    search.formParams.q = '';
                                    search.resetSuggestions(evt);
                                    search.closeSuggestions();
                                    search.hidePopup();
                                    var dummySearchPanel = document.querySelector('.navigation-dropdown__panel--search');
                                    dummySearchPanel.focus();
                                    evt.preventDefault();
                                }
                            });
                        }
                    }
                });
            }
        }, 1000);

        if (document.getElementById('sparksDropdown')) {
            //toggle link for sparks in sign-in drop-down- mobile
            var elMobile = document.querySelector('.navigation-header__sparks-link-signin-mobile');
            if (elMobile) {
                var url = mnsCookieService.isUserSparksMember() ? elMobile.getAttribute('data-sparks-hub-link') : elMobile.getAttribute('data-sparks-login-link');
                elMobile.setAttribute('data-href', url);
            }
        }

        // set tabindex for visually hidden elements
        var notVisibleToAllBreakpoints = '.navigation-dropdown__panel-wrapper button[type=reset], .navigation-suggestion-item--recent';
        var selectorsToRemoveMdToLrgBreakpoint = '.navigation-res-nav-header__icon--fav, .navigation-btn__icon--search-container';
        var selectorsToRemoveSmallBreakpoints = '.navigation-dropdown__panel-wrapper input[type=search]';
        var extraSelectors = (Breakpoint.size() === 'medium' || Breakpoint.size() === 'large') ? selectorsToRemoveMdToLrgBreakpoint : selectorsToRemoveSmallBreakpoints;
        var selectorsToRemove = document.querySelectorAll(notVisibleToAllBreakpoints + extraSelectors);
        var navList = document.querySelector('.navigation-primary__section');
        var navL23 = document.getElementById('navContainer');
        util.setTabIndex(selectorsToRemove, -1);

        HdrSiteStripe.initHdrSiteStripeCarousel(requestParams.storeId);
        var _this = this;
        // when tablet orientation changes
        window.addEventListener('resize', onResizeEvent);

        function onResizeEvent() {
            var promoSlides = document.querySelectorAll('.navigation-sitestripe__slide');
            var isIEorEdge = util.checkIeVersion();
            var ipadMenu = document.querySelector('.navigation-hamburger-trigger');

            for (var index = 0; index < promoSlides.length; index++) {
                promoSlides[index].removeAttribute('style');
                if (!isIEorEdge) {
                    promoSlides[index].firstElementChild.removeAttribute('style');
                }
            }
            // bind the 'search' dropdown
            if (Breakpoint.size() === 'xsmall') {
                var searchInput = document.querySelector('.navigation-search-overlay .navigation-res-nav-header__dropdown--search .navigation-search-bar--search');
                searchInput.autofocus = true;
                navList.style.transition = 'none';
                _this.searchIconDisplay = document.querySelector('.navigation-dropdown__panel--search');
                _this.searchButton = document.querySelector('.navigation-res-nav-header__search .navigation-search-bar--submit');
                _this.headerSection = document.getElementById('progressiveHeaderSection');
                document.querySelector('.navigation-btn__icon--search').innerText = '';
                document.querySelector('.navigation-header__title-text__desktop').innerText = '';
                if (_this.searchIconDisplay) {
                    domQ(_this.searchIconDisplay).removeClass('navigation-dropdown__panel-wrapper', 'navigation-dropdown__panel--search');
                    domQ(_this.searchIconDisplay).addClass('navigation-dropdown__panel-wrapper__new', 'navigation-dropdown__panel--search');
                }
                if (!window.siteStripeKey) {
                    document.querySelector('.navigation-sitestripe').style.display = 'none';
                }
                var userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
                var dummySearchBar = document.querySelector('.navigation-res-nav-header__search .navigation-search-bar--search-wrap');
                if (/iPad/.test(userAgent) && (window.innerWidth === 768 || window.innerWidth === 767)) {
                    document.querySelector('.navigation-res-nav-header__search').style.display = 'block';
                    document.querySelector('.navigation-btn__icon--search').style.display = 'none';
                    document.querySelector('.navigation-btn__icon--search-container').style.display = 'none';
                    domQ(_this.headerSection).hasClass('navigation-header-height') ? domQ(_this.headerSection).removeClass('navigation-header-height') : '';
                    dummySearchBar = document.querySelector('.navigation-res-nav-header__search .navigation-search-bar--search-wrap');
                    domQ(dummySearchBar).addClass('navigation-search-bar--search-wrap__full-width');
                } else if (window.mobileSearchKey) { //collapsed on resize
                    document.querySelector('.navigation-res-nav-header__search').style.display = 'none';
                    document.querySelector('.navigation-dropdown__panel--search').style.display = 'none';
                    document.querySelector('.navigation-btn__icon--search-container').style.display = 'block';
                    document.querySelector('.navigation-btn__icon--search').style.display = 'block';
                    domQ(_this.headerSection).addClass('navigation-header-height');
                } else { //exposed on resize
                    document.querySelector('.navigation-res-nav-header__search').style.display = 'block';
                    document.querySelector('.navigation-dropdown__panel--search').style.display = 'block';
                    document.querySelector('.navigation-btn__icon--search').style.display = 'none';
                    document.querySelector('.navigation-btn__icon--search-container').style.display = 'none';
                    domQ(_this.headerSection).hasClass('navigation-header-height') ? domQ(_this.headerSection).removeClass('navigation-header-height') : '';
                    dummySearchBar = document.querySelector('.navigation-res-nav-header__search .navigation-search-bar--search-wrap');
                    domQ(dummySearchBar).addClass('navigation-search-bar--search-wrap__full-width');
                }
                if ((window.innerWidth !== 767) || (window.innerWidth !== 768)) {
                    _this.mnslogo = document.querySelector('.navigation-logo');
                    domQ(_this.mnslogo).hasClass('navigation-logo-ipad-portrait') ? domQ(_this.mnslogo).removeClass('navigation-logo-ipad-portrait') : '';
                    _this.ipadinput = document.querySelector('.navigation-dropdown__panel--search');
                    if (_this.ipadinput) {
                        domQ(_this.ipadinput).hasClass('navigation-search-bar-ipad-portrait') ? domQ(_this.ipadinput).removeClass('navigation-search-bar-ipad-portrait') : '';
                    }
                    _this.Ipadresize = document.querySelector('.navigation-res-nav-header__search .navigation-search-bar--search-wrap');
                    if (_this.Ipadresize) {
                        domQ(_this.Ipadresize).hasClass('navigation-search-warp-ipad-portrait') ? domQ(_this.Ipadresize).removeClass('navigation-search-warp-ipad-portrait') : '';
                    }
                    ipadMenu = document.querySelector('.navigation-hamburger-trigger');
                    if (ipadMenu) {
                        domQ(ipadMenu).hasClass('navigation-hamburger-ipad-portrait') ? domQ(ipadMenu).removeClass(ipadMenu, 'navigation-hamburger-ipad-portrait') : '';
                    }
                    if (_this.headerSection) {
                        domQ(_this.headerSection).hasClass('navigation-header-ipad-height') ? domQ(_this.headerSection).removeClass('navigation-header-ipad-height') : '';
                    }
                }
                var l1menuContainer = document.querySelector('.navigation-primary__section');
                var innerHeight = window.innerHeight;
                var aHeight = (innerHeight - 61);
                l1menuContainer.style.height = aHeight + 'px';
                var bottompadding = document.querySelector('.navigation-primary__section');
                bottompadding.style.paddingBottom = '0';
            } else {
                var body = document.querySelector('body');
                var elementClearIndesktop = document.querySelector('.navigation-hdr-search-bar--clear');
                body.addEventListener('click', activeElementListener);
                navList.removeAttribute('style');
                navL23.removeAttribute('style');
                document.querySelector('.navigation-btn__icon--search-container').removeAttribute('style');
                document.querySelector('.navigation-dropdown__panel--search').removeAttribute('style');
                _this.searchIconDisplay = document.querySelector('.navigation-dropdown__panel-wrapper__new');
                document.querySelector('.navigation-res-nav-header__search').style.display = 'block';
                document.querySelector('.navigation-header__title-text__desktop').innerText = '';
                document.querySelector('.navigation-btn__icon--search').style.display = 'block';
                domQ(_this.headerSection).hasClass('navigation-header-height') ? domQ(_this.headerSection).removeClass('navigation-header-height') : '';
                if (_this.searchIconDisplay) {
                    domQ(_this.searchIconDisplay).removeClass('navigation-dropdown__panel-wrapper__new', 'navigation-dropdown__panel--search');
                    domQ(_this.searchIconDisplay).addClass('navigation-dropdown__panel-wrapper', 'navigation-dropdown__panel--search');
                }
                if (elementClearIndesktop.hasAttribute('style')) {
                    elementClearIndesktop.removeAttribute('style');
                }
            }

            if (document.querySelector('.navigation-sitestripe').classList.contains('navigation-no-stripe')) {
                HdrSiteStripe.initHdrSiteStripeCarousel(requestParams.storeId);
            } else if (Breakpoint.size() !== 'xsmall') {
                document.querySelector('.navigation-sitestripe').style.display = 'block';
            }
            // Ipad portrait to land scape responsive code
            if (Breakpoint.size() !== 'xsmall') {
                _this.dockSearchPopup = document.querySelector('.navigation-dock-search-popup');
                _this.searchBarSuggestion = document.querySelector('.navigation-search-bar--suggestion-dropdown');
                _this.searchsuggestionList = document.querySelector('.navigation-search-item--list li');
                _this.searchbardropdownDiv = document.querySelector('.navigation-search-bar--dropdowndiv');
                _this.searchSuggestionTitle = document.querySelector('.navigation-suggestion-item--title');
                _this.clearRecentSearchText = document.querySelector('.navigation-suggestion-item--clear-text');
                _this.suggestionItemClear = document.querySelector('.navigation-suggestion-item--title .navigation-suggestion-item--clear');
                _this.searchClearRecent = document.querySelector('.navigation-recentsearch--list .navigation-suggestion-item--recent');
                if (_this.dockSearchPopup) {
                    domQ(_this.dockSearchPopup).hasClass('navigation-hdr-sticky-class') ? domQ(_this.dockSearchPopup).removeClass('navigation-hdr-sticky-class') : '';
                    if (_this.searchBarSuggestion) {
                        document.querySelector('.navigation-search-bar--suggestion-dropdown').removeEventListener('touchstart', search.stickySearch);
                    }
                }
                if (_this.searchBarSuggestion) {
                    domQ(_this.searchBarSuggestion).hasClass('navigation-suggestion-list-padding') ? domQ(_this.searchBarSuggestion).removeClass('navigation-suggestion-list-padding') : '';
                }
                if (_this.SearchsuggestionList) {
                    domQ(_this.searchbardropdownDiv).hasClass('navigation-scroll-height') ? domQ(_this.searchbardropdownDiv).removeClass('navigation-scroll-height') : '';
                }
                if (_this.suggestionItemClear) {
                    _this.suggestionItemClear.innerText = '';
                    domQ(_this.suggestionItemClear).hasClass('navigation-suggestion-item--clear') ? domQ(_this.suggestionItemClear).removeClass('navigation-suggestion-item--clear') : '';

                }
                if (_this.clearRecentSearchText && _this.searchClearRecent) {
                    _this.clearRecentSearchText.innerText = 'Clear';
                }
                if (_this.searchSuggestionTitle && !_this.clearRecentSearchText) {
                    _this.clearElement = document.createElement('div');
                    _this.recentElement = document.querySelector('.navigation-suggestion-item--title');
                    _this.recentSearchList = document.querySelector('.navigation-recentsearch--list');
                    _this.clearElementdevice = document.createElement('span');
                    _this.clearElementdevice.tabIndex = '-1';
                    _this.clearElementdevice.setAttribute('aria-label', 'Clear');
                    _this.clearElementdevice.innerHTML = 'Clear';
                    domQ(_this.clearElementdevice).addClass('navigation-suggestion-item--clear-text');
                    domQ(_this.clearElement).addClass('suggestion-item');
                    domQ(_this.clearElement).addClass('navigation-suggestion-item--clear');
                    _this.clearElement.appendChild(_this.clearElementdevice);
                    if (_this.recentSearchList) {
                        _this.recentSearchList.appendChild(_this.clearElement);
                    }
                    _this.clearElementdevice.addEventListener('click', clearElmntDevice);
                }

                //Ipad 767 view portrait to landscape
                if ((window.innerWidth !== 767) || (window.innerWidth !== 768)) {
                    _this.mnslogo = document.querySelector('.navigation-logo');
                    domQ(_this.mnslogo).hasClass('navigation-logo-ipad-portrait') ? domQ(_this.mnslogo).removeClass('navigation-logo-ipad-portrait') : '';
                    _this.ipadinput = document.querySelector('.navigation-dropdown__panel--search');
                    if (_this.ipadinput) {
                        domQ(_this.ipadinput).hasClass('navigation-search-bar-ipad-portrait') ? domQ(_this.ipadinput).removeClass('navigation-search-bar-ipad-portrait') : '';
                    }
                    _this.Ipadresize = document.querySelector('.navigation-res-nav-header__search .navigation-search-bar--search-wrap');
                    if (_this.Ipadresize) {
                        domQ(_this.Ipadresize).hasClass('navigation-search-warp-ipad-portrait') ? domQ(_this.Ipadresize).removeClass('navigation-search-warp-ipad-portrait') : '';
                    }
                    ipadMenu = document.querySelector('.navigation-hamburger-trigger');
                    if (ipadMenu) {
                        domQ(ipadMenu).hasClass('navigation-hamburger-ipad-portrait') ? domQ(ipadMenu).removeClass(ipadMenu, 'navigation-hamburger-ipad-portrait') : '';
                    }
                    if (_this.headerSection) {
                        domQ(_this.headerSection).hasClass('navigation-header-ipad-height') ? domQ(_this.headerSection).removeClass('navigation-header-ipad-height') : '';
                    }
                }
            } else {
                _this.searchBarSuggestion = document.querySelector('.navigation-search-bar--suggestion-dropdown');
                _this.searchCleartext = document.querySelector('.navigation-suggestion-item--title .suggestion-item');
                if (_this.searchBarSuggestion) {
                    document.querySelector('.navigation-search-bar--suggestion-dropdown').addEventListener('touchstart', search.stickySearch);
                }
                if (!_this.searchCleartext) {
                    _this.clearElementdevice = document.createElement('span');
                    _this.clearElementdevice.innerHTML = 'Clear';
                    domQ(_this.clearElementdevice).addClass('suggestion-item');
                    domQ(_this.clearElementdevice).addClass('navigation-suggestion-item--clear');
                    if (document.querySelector('.navigation-suggestion-item--title')) {
                        document.querySelector('.navigation-suggestion-item--title').appendChild(_this.clearElementdevice);
                    }
                    _this.clearElementdevice.addEventListener('click',
                        function () {
                            _this.localStorage = window.localStorage;
                            search.clearRecentSearches();
                        });
                }
                if (_this.searchCleartext) {
                    _this.searchCleartext.innerText = 'Clear';
                    domQ(_this.searchCleartext).addClass('navigation-suggestion-item--clear');
                }
                if (_this.clearRecentSearchText) {
                    _this.clearRecentSearchText.innerText = '';
                }
                //IPAD 767 landscape to portrait
                if (/iPad/.test(userAgent) && (window.innerWidth === 768 || window.innerWidth === 767)) {
                    _this.mnslogo = document.querySelector('.navigation-logo');
                    _this.ipadinput = document.querySelector('.navigation-dropdown__panel--search');
                    _this.Ipadresize = document.querySelector('.navigation-res-nav-header__search .navigation-search-bar--search-wrap');
                    domQ(_this.mnslogo).addClass('navigation-logo-ipad-portrait');
                    domQ(_this.ipadinput).addClass('navigation-search-bar-ipad-portrait');
                    domQ(_this.Ipadresize).addClass('navigation-search-warp-ipad-portrait');
                    domQ(_this.headerSection).addClass('navigation-header-ipad-height');
                }
            }
            var recentSearchLength = document.querySelectorAll('.suggestion-item.navigation-suggestion-item--recent').length;
            var clearElement = document.querySelector('.navigation-suggestion-item--clear');
            var clearTextElement = document.querySelector('.navigation-suggestion-item--clear-text');

            // search overlay design for desktop breakpoint
            if ((Breakpoint.size() === 'medium' || Breakpoint.size() === 'large')) {
                if (clearTextElement) {
                    clearTextElement.innerHTML = CLEAR;
                }
                if (recentSearchLength === 1) {
                    clearElement.style.top = '-7.8rem';
                } else if (recentSearchLength === 2) {
                    clearElement.style.top = '-11.5rem';
                }
                else if (recentSearchLength === 2) {
                    clearElement.style.top = '-15.2rem';
                }

                var recentElement = document.querySelector('.navigation-suggestion-item--title'),
                    suggestionListArray = document.querySelectorAll('.navigation-search-item--list li.suggestion-item'),
                    suggestionList = document.querySelector('.navigation-search-item--list');
                if (suggestionListArray.length !== 0) {
                    if (recentElement) {
                        domQ(suggestionList).addClass('navigation-recent-serach-underline');
                    }
                }
                else if (suggestionListArray.length === 0) {
                    if (recentElement) {
                        domQ(suggestionList).removeClass('navigation-recent-serach-underline');
                    }
                }
                if (recentElement) {
                    var recentSearchList = document.querySelector('.navigation-recentsearch--list');
                    recentSearchList.style.maxHeight = '1000px';
                    recentSearchList.style.opacity = 1;
                    recentElement.style.maxHeight = '1000px';
                    recentElement.style.opacity = 1;
                }
            }
            else if (Breakpoint.size() === 'small') {
                if (recentSearchLength === 1) {
                    clearElement.style.top = '-7.8rem';
                }
                else if (recentSearchLength === 2) {
                    clearElement.style.top = '-12.3rem';
                }
                else if (recentSearchLength === 3) {
                    clearElement.style.top = '-16.8rem';
                }
            }
        }

        function clearElmntDevice() {
            _this.localStorage = window.localStorage;
            search.clearRecentSearches();
        }
        // Ipad portrait to land scape responsive code --End here

        function activeElementListener() {
            window.activeElement = document.activeElement;
        }

        function touchHandlerForDropdown(e) {
            if (e.target) {
                if ((e.target.className !== 'navigation-res-nav-header__item navigation-res-nav-header__item--login' || e.target.className === '') &&
                    e.target.parentNode.className !== 'navigation-dropdown__list-container-signin') {
                    domQ(document.querySelector('.navigation-signin-wrapper')).addClass('navigation-signin-wrapper-hidden');
                }
                if ((e.target.className !== 'navigation-res-nav-header__item navigation-res-nav-header__item--myaccount' || e.target.className === '') &&
                    e.target.parentNode.className !== 'navigation-dropdown__list-container-myaccount') {
                    domQ(document.querySelector('.navigation-signacc-wrapper')).addClass('navigation-signacc-wrapper-hidden');
                }
                if ((domQ(document.querySelector('.navigation-minibag-dock-overlay')).hasClass('navigation-dock-overlay--block') ||
                    e.target.parentNode.className !== 'navigation-dock-overlay__inner' ||
                    e.target.parentNode.className !== 'navigation-hdr-mini-bag__item-detail')) {
                    var hasBagOverlayParent = hasSomeParentTheClass(e.target.parentNode, 'navigation-dock-overlay__inner');
                    if (!hasBagOverlayParent) {
                        domQ(document.querySelector('.navigation-minibag-dock-overlay')).removeClass('navigation-dock-overlay--block');
                        domQ(document.querySelector('.navigation-minibag-dock-overlay')).removeClass('navigation-dock-overlay--transition');
                    }
                }
                var userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
                if (/iPad/.test(userAgent)) {
                    if ((e.target.className === 'navigation-primary__menu-icon navigation-icon--my-account' || e.target.className === 'navigation-res-nav-header__login-link') &&
                        (e.target.parentNode.className === 'navigation-res-nav-header__login-link' || e.target.parentNode.className === 'navigation-res-nav-header__item navigation-res-nav-header__item--login')) {
                        domQ(document.querySelector('.navigation-signin-wrapper')).removeClass('navigation-signin-wrapper-hidden');
                        domQ(document.querySelector('.navigation-header__signin')).addClass('navigation-header__sign-in');
                    }
                    if ((e.target.className === 'navigation-primary__menu-icon navigation-icon--account-active' || e.target.className === 'navigation-res-nav-header__icon--my-account') &&
                        (e.target.parentNode.className === 'navigation-res-nav-header__icon--my-account' || e.target.parentNode.className === 'navigation-res-nav-header__item navigation-res-nav-header__item--myaccount navigation-myaccount navigation-dropdown')) {
                        domQ(document.querySelector('.navigation-signacc-wrapper')).removeClass('navigation-signacc-wrapper-hidden');
                        domQ(document.querySelector('.navigation-header__sub-list-container--signacc')).addClass('navigation-header__sub-list-container--signacc-displayblock');
                    }
                }
            }
        }

        // returns true if the element or one of it's parents has the given className
        function hasSomeParentTheClass(element, classname) {
            if (element && element.className && element.className.split(' ').indexOf(classname) >= 0) {
                return true;
            }
            return element.parentNode && hasSomeParentTheClass(element.parentNode, classname);
        }

        // Skip to page content accessibility
        //Accessibility for main page content

        var headerEl = document.querySelector('#common-hdr-main');
        var pageContent = headerEl ? headerEl.nextElementSibling : false;
        var initialContentLink = '';
        var navSkipLink = document.querySelector('.navigation-skip-content button');
        if (pageContent) {
            initialContentLink = pageContent.querySelector('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
            while (pageContent && pageContent !== null && !initialContentLink) {
                pageContent = pageContent.nextElementSibling;
                if (pageContent) {
                    initialContentLink = pageContent.querySelector('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
                }
            }
            if (initialContentLink) {
                navSkipLink.addEventListener('click', skipToMainEvnt);
            }
        }
        function skipToMainEvnt() {
            initialContentLink.focus();
        }
        //sticky header
        window.addEventListener('scroll', navStickyScrollEvent);
        window.addEventListener('resize', navStickyRemoveOnResize);
        var lastScrollTop = 0;
        var hamburgerMenu = document.querySelector('.navigation-primary__section');
        var userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
        var HeaderSticked = false;
        var stickyHeaderDiv = document.querySelector('.navigation-tostick');
        var stickyAddtoCartPDP = document.querySelector('.sticky-add-to-bag');

        function navStickyRemoveOnResize() {
            if (Breakpoint.size() !== 'xsmall' && HeaderSticked) {
                headerEl.removeAttribute('style');
                if (domQ(headerEl).hasClass('navigation-sticky')) {
                    domQ(headerEl).removeClass('navigation-sticky-in');
                    setTimeout(function () {
                        domQ(headerEl).removeClass('navigation-sticky');
                        headerEl.removeAttribute('style');
                        stickyHeaderDiv.removeAttribute('style');
                    }, 10);
                }
                if (stickyAddtoCartPDP && domQ(stickyAddtoCartPDP).hasClass('navigation-sticky-pdp-top')) {
                    domQ(stickyAddtoCartPDP).removeClass('navigation-sticky-pdp-top');
                }
                stickyHeader.unbindAccessibility();
                HeaderSticked = false;
            }
        }

        function navStickyScrollEvent() {
            if (/iPhone|iPod/.test(userAgent) && !window.MSStream) {
                if (domQ(hamburgerMenu).hasClass('navigation-is-active')) {
                    window.scrollTo(0, window.initialStickyScroll);
                    return false;
                }
            }

            if (window.HIDE_MS_COMMON_HDR_STICKY || userAgent.indexOf('MSIE') !== -1 || window.navigator.appVersion.indexOf('Trident/') > 0 || Breakpoint.size() !== 'xsmall') {
                return false;
            }

            var pageType = document.getElementById('pageType') ? document.getElementById('pageType').innerText : false;
            var currentScrollTop = window.pageYOffset || document.documentElement.currentScrollTop;
            var stickyFilterPLP = document.querySelector('.container--plp .sticky');
            var srpSticky = document.querySelector('.search-result-content .sticky');
            var findPages = document.querySelector('.filter-sticky-bar.filter-sticky-bar-sticky');

            if (pageType === 'PLP' && stickyFilterPLP) {
                stickyFilterPLP.style.transition = 'padding-top .5s ease';
            }
            if (pageType === 'SRP' && srpSticky) {
                srpSticky.style.transition = 'padding-top .5s ease';
            }
            if (findPages) {
                findPages.style.transition = 'padding-top .5s ease';
            }

            function addStickyToHeader() {
                if (domQ(headerEl).hasClass('navigation-sticky-in') && !domQ(headerEl).hasClass('navigation-sticky')) {
                    domQ(headerEl).removeClass('navigation-sticky-in');
                    HeaderSticked = false;
                    return false;
                }
                if (!HeaderSticked) {
                    headerEl.style.height = headerEl.offsetHeight + 'px';
                    domQ(headerEl).addClass('navigation-sticky');
                    setTimeout(function () {
                        domQ(headerEl).addClass('navigation-sticky-in');
                    }, 10);
                    if (stickyAddtoCartPDP && !domQ(stickyAddtoCartPDP).hasClass('navigation-sticky-pdp-top')) {
                        domQ(stickyAddtoCartPDP).addClass('navigation-sticky-pdp-top');
                    }
                    stickyHeader.bindAccessibility(document.activeElement);
                    setTimeout(function () {
                        stickyHeaderDiv.style.transition = 'top .65s ease';
                    }, 500);
                    HeaderSticked = true;
                }
            }

            function removeStickyHeader() {
                if (HeaderSticked) {
                    if (domQ(headerEl).hasClass('navigation-sticky')) {
                        if (domQ(headerEl).hasClass('navigation-sticky-in')) {
                            domQ(headerEl).removeClass('navigation-sticky-in');
                        }
                        setTimeout(function () {
                            domQ(headerEl).removeClass('navigation-sticky');
                            headerEl.removeAttribute('style');
                            stickyHeaderDiv.removeAttribute('style');
                        }, 500);
                    }
                    if (stickyAddtoCartPDP && domQ(stickyAddtoCartPDP).hasClass('navigation-sticky-pdp-top')) {
                        domQ(stickyAddtoCartPDP).removeClass('navigation-sticky-pdp-top');
                    }
                    stickyHeader.unbindAccessibility();
                    HeaderSticked = false;
                }
            }

            function removeStickyHeaderWithoutDelay() {
                if (HeaderSticked) {
                    headerEl.removeAttribute('style');
                    if (domQ(headerEl).hasClass('navigation-sticky')) {
                        domQ(headerEl).removeClass('navigation-sticky-in');
                        setTimeout(function () {
                            domQ(headerEl).removeClass('navigation-sticky');
                            headerEl.removeAttribute('style');
                            stickyHeaderDiv.removeAttribute('style');
                        }, 10);
                    }
                    if (stickyAddtoCartPDP && domQ(stickyAddtoCartPDP).hasClass('navigation-sticky-pdp-top')) {
                        domQ(stickyAddtoCartPDP).removeClass('navigation-sticky-pdp-top');
                    }
                    stickyHeader.unbindAccessibility();
                    HeaderSticked = false;
                }
            }


            function stickyCondition() {
                if (currentScrollTop > lastScrollTop) {
                    removeStickyHeader();
                    lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // For Mobile or negative scrolling
                } else {
                    if (lastScrollTop - currentScrollTop > 100) {
                        addStickyToHeader();
                        lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // For Mobile or negative scrolling
                    }
                }
            }
            if (window.navSkiptoPage === true) {
                removeStickyHeaderWithoutDelay();
                window.navSkiptoPage = false;
            }
            if (currentScrollTop > 600) {
                if (headerEl && headerEl.style.display !== 'none') {
                    stickyCondition();
                }
            }
            if (currentScrollTop < 600) {
                lastScrollTop = 0;
                if (headerEl && headerEl.style.display !== 'none') {
                    removeStickyHeaderWithoutDelay();
                }
            }
            if (!currentScrollTop) {
                removeStickyHeaderWithoutDelay();
            }
        }

        /* providing display none to common header in mobile app web view pages */
        var platformCookie = document.cookie.match('platform');
        var commonHeaderSection = document.querySelector('.navigation-common-hdr-main');
        if ((platformCookie !== null) && (platformCookie.input) && (commonHeaderSection)) {
            (platformCookie.input.indexOf('mobileapp') !== -1) ? commonHeaderSection.style.display = 'none' : false;
        }

        // AT dashboard welcom message
        window.addEventListener('load', function () {
            sparksDashboard.init();
        });

        var signinIconlabel = document.querySelector('.navigation-res-nav-header__item--login .navigation-icon--my-account');
        var signinIconlabelText = document.querySelector('.navigation-signintext');
        function triggeranimation(callback) {
            if (signinIconlabel) {
                var _this = callback;
                setTimeout(function () {
                    domQ(signinIconlabel).addClass('remove-login-icon');
                    _this();
                }, 3000);
            }
        }
        function signanimate() {
            if (signinIconlabelText) {
                setTimeout(function () {
                    domQ(signinIconlabelText).addClass('navigation-signintextanimate');
                }, 500);
            }
        }

        window.addEventListener('load', function () {
            triggeranimation(signanimate);
        });
        if (window.innerWidth <= '768') {
            var l1menuContainer = document.querySelector('.navigation-primary__section');
            var innerHeight = window.innerHeight;
            var aHeight = (innerHeight - 61);
            if (l1menuContainer) {
                l1menuContainer.style.height = aHeight + 'px';
            }
            var bottompadding = document.querySelector('.navigation-primary__section');
            if (bottompadding) {
                bottompadding.style.paddingBottom = '0';
            }

        }
    }

    return Header;
});



// WEBPACK FOOTER //
// ./src/mns-core-ui-header/templates/header/js/Index.js